import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vue-app" }
const _hoisted_2 = { class: "bg-gascon-gray" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AppHeader = _resolveComponent("AppHeader")
  const _component_HeroSection = _resolveComponent("HeroSection")
  const _component_PhoneImageSection = _resolveComponent("PhoneImageSection")
  const _component_CategoriesSection = _resolveComponent("CategoriesSection")
  const _component_NewsSection = _resolveComponent("NewsSection")
  const _component_ContactSection = _resolveComponent("ContactSection")
  const _component_GallerySection = _resolveComponent("GallerySection")
  const _component_TeamSection = _resolveComponent("TeamSection")
  const _component_AppFooter = _resolveComponent("AppFooter")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Header "),
    _createVNode(_component_AppHeader),
    _createCommentVNode(" Main content "),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_HeroSection),
      _createVNode(_component_PhoneImageSection),
      _createVNode(_component_CategoriesSection),
      _createVNode(_component_NewsSection, { news: $data.news }, null, 8 /* PROPS */, ["news"]),
      _createVNode(_component_ContactSection),
      _createVNode(_component_GallerySection, { images: $data.galleryImages }, null, 8 /* PROPS */, ["images"]),
      _createVNode(_component_TeamSection, { members: $data.teamMembers }, null, 8 /* PROPS */, ["members"])
    ]),
    _createCommentVNode(" Footer "),
    _createVNode(_component_AppFooter)
  ]))
}